import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Header from "../common/Header/index";
import Footer from "../common/Footer/index";
import PageWrapper from "../common/PageWrapper/index";
import { generatePDF } from "../../services/pdfService";
import "./PdfGeneration.css";
import { useState } from "react";

const PdfGeneration = ({ menuState }) => {
  const { isMenuOpen, setIsMenuOpen, onMenuToggle } = menuState || {};
  const location = useLocation();
  const { formData } = location.state || {};

  const documentSections = {
    INTERNE: {
      title: "INTERNE",
      documents: [
        { id: "etiquette_vertical", label: "Étiquette dossier vertical" },
        { id: "etiquette_horizontal", label: "Étiquette dossier horizontal" },
        { id: "etiquette_cle", label: "Étiquette clé" },
        { id: "dossier", label: "Dossier" },
        { id: "chemise_achat", label: 'Chemise "Achat"' },
        { id: "chemise_vente", label: 'Chemise "Vente"' },
        { id: "chemise_carte_grise", label: 'Chemise "Carte grise"' },
      ],
    },
    ACHAT: {
      title: "ACHAT",
      documents: [
        {
          id: "certificat_cession_achat",
          label: "Certificat de cession / Achat",
        },
        { id: "declaration_achat", label: "Déclaration d'achat" },
      ],
    },
    VENTE: {
      title: "VENTE",
      documents: [
        { id: "fiche_preparation", label: "Fiche de préparation - atelier" },
        { id: "fiche_reception", label: "Fiche de réception" },
        { id: "mandat", label: "Mandat" },
        { id: "certificat_cession", label: "Certificat de cession" },
        {
          id: "demande_immatriculation_vo",
          label: "Demande d'immatriculation VO",
        },
        {
          id: "demande_immatriculation_vn",
          label: "Demande d'immatriculation VN",
        },
        { id: "confirmation_commande", label: "Confirmation de commande" },
        { id: "check_list_client", label: "Check list pour le client" },
        { id: "fiche_mise_main", label: "Fiche de mise en main" },
        { id: "decharge_responsabilite", label: "Décharge de responsabilité" },
      ],
    },
  };

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleDocumentSelect = (docId) => {
    setSelectedDocs((prev) =>
      prev.includes(docId)
        ? prev.filter((id) => id !== docId)
        : [...prev, docId]
    );
  };

  const handleDownload = async () => {
    if (selectedDocs.length === 0) return;

    try {
      const pdfBlob = await generatePDF({
        ...formData,
        documents: selectedDocs,
      });
      const url = window.URL.createObjectURL(pdfBlob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Erreur lors de la génération des PDFs:", error);
    }
  };

  return (
    <div className="pdf-generation-page">
      <Header
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onMenuToggle={onMenuToggle}
      />
      <PageWrapper isMenuOpen={isMenuOpen}>
        <div className="pdf-generation-header">
          <h2>Formulaire de renseignements</h2>
        </div>
        <div className="success-message">
          <h2>Bravo !</h2>
          <p>Bravo, votre nouveau formulaire a bien été créé.</p>
          <p>
            Vous pouvez dès à présent sélectionner et télécharger les documents
            suivants :
          </p>
        </div>
        <div className="pdf-generation-container">
          <div className="pdf-content">
            <div className="documents-container">
              {Object.values(documentSections).map((section) => (
                <div key={section.title} className="document-section">
                  <h3>{section.title}</h3>
                  <div className="document-list">
                    {section.documents.map((doc) => (
                      <div key={doc.id} className="document-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={selectedDocs.includes(doc.id)}
                            onChange={() => handleDocumentSelect(doc.id)}
                          />
                          <span>{doc.label}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="download-section">
              <button
                className="download-button-pdf"
                onClick={handleDownload}
                disabled={selectedDocs.length === 0}
              >
                Télécharger
              </button>
              <p className="pdf-note">
                les documents pré-remplis au format PDF
              </p>
            </div>
          </div>
        </div>
      </PageWrapper>
      <Footer />
    </div>
  );
};

PdfGeneration.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool,
    setIsMenuOpen: PropTypes.func,
    onMenuToggle: PropTypes.func,
  }),
};

export default PdfGeneration;
